import React from 'react';

import FormStepContainer from './FormStepContainer';
import ClinicForm from './ClinicForm';

const ClinicStep = () => (
  <FormStepContainer title="Dados da clínica">
    <ClinicForm />
  </FormStepContainer>
);

export default ClinicStep;
